import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

function loadLocaleMessages () {
  return {
    'en': require('@/common/lang/en'),   // 英文语言包
    'vn': require('@/common/lang/vn'),   // 越南文语言包
  };
}

export default new VueI18n({
  locale:'vn',
  fallbackLocale:'en',
  messages: loadLocaleMessages()
})
